import { IconBaseProps, IconType } from 'react-icons';
import React from 'react';
import { CustomSVG } from '@/types/common.ts';
import { Flex, FlexProps } from '@mantine/core';
import { useHover } from '@mantine/hooks';

type AppIconProps = FlexProps & {
  Icon?: IconType;
  CustomIcon?: CustomSVG;
  size?: number | string;
  iconProps?: IconBaseProps;
  color?: string;
  hoverIconProps?: IconBaseProps;
};

export const AppIcon: React.FC<AppIconProps> = ({
  Icon,
  CustomIcon,
  size = 20,
  iconProps,
  style,
  color,
  hoverIconProps,
  ...props
}) => {
  const { hovered, ref: hoverRef } = useHover();

  return (
    <Flex
      ref={hoverRef}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        ...style,
      }}
      {...props}
    >
      {Icon && (
        <Icon size={size} color={color} {...iconProps} {...(hovered ? hoverIconProps : {})} />
      )}
      {CustomIcon && <CustomIcon width={size} height={size} color={color} strokeWidth={'1px'} />}
    </Flex>
  );
};

export default AppIcon;
